/** Sort direction — UI and API `orderDirection` always `asc` / `desc`. */
export const TableSort = {
  ASC: "asc",
  DESC: "desc",
} as const;

export type TableSortValue = (typeof TableSort)[keyof typeof TableSort];

/** Normalize any casing to `TableSort`. */
export const toTableSort = (direction?: string | null): TableSortValue =>
  String(direction).toLowerCase() === TableSort.ASC
    ? TableSort.ASC
    : TableSort.DESC;
